export const createContestsEditionStageTableJudgesRequests = (client) => ({
    listContestsEditionStageTableJudges: async (params) => {
        const { data, meta, links } = await client.api.get("contests_edition_stage_table_judges", {
            params: params,
        });
        return { data, meta, links };
    },
    getContestsEditionStageTableJudge: async (id, params) => {
        const { data } = await client.api.get(`contests_edition_stage_table_judges/${id}`, {
            params: params,
        });
        return { data };
    },
    createContestsEditionStageTableJudge: async (payload) => {
        const { data } = await client.api.create("contests_edition_stage_table_judges", payload);
        return { data };
    },
    updateContestsEditionStageTableJudge: async (payload) => {
        const { data } = await client.api.update("contests_edition_stage_table_judges", payload);
        return { data };
    },
    deleteContestsEditionStageTableJudge: async (id) => {
        return client.api.remove("contests_edition_stage_table_judges", id);
    },
    promoteContestsEditionStageTableJudge: async (payload) => {
        const { data } = await client.api.request({
            type: "contests_edition_stage_table_judges",
            url: `/contests_edition_stage_table_judges/${payload?.id}/promote`,
            method: "PATCH",
            body: payload,
        });
        return { data };
    },
});
//# sourceMappingURL=index.js.map